module.exports = __webpack_public_path__ + "img/kids-1.b47a7d0a.jpg";